import React from 'react';
export function CTASection() {
  return <section id="contact" className="py-16 bg-[#3A4A46] text-white" data-id="element-162" data-mp="1eavhhh21vfyt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163" data-mp="27howkcyrjwf6">
        <div className="max-w-3xl mx-auto text-center" data-id="element-164" data-mp="2cfqhl3fr25ta">
          <div className="flex justify-center mb-8" data-id="element-165" data-mp="2ce5lvahp8gtu">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cxY6qWzHxoq8pm6btP29jY/White_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-20 w-auto" data-id="element-166" data-mp="2hfcrb2wdd3xc" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-167" data-mp="2qdyifmfwpr9q">
            Ready to hand off your bookkeeping and tax needs with confidence?
          </h2>
          <p className="text-xl mb-8" data-id="element-168" data-mp="3051gefdjhq4s">
            <span className="block mb-2" data-id="element-169" data-mp="303zyps20q5e3">
              Schedule your free discovery call today
            </span>
            <span className="block" data-id="element-170" data-mp="3568pqivbyxdk">
              and take the first step toward financial clarity.
            </span>
          </p>
          <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#9BAB6C] text-white px-8 py-4 rounded-md text-lg font-medium hover:bg-opacity-90 transition-colors" data-id="element-171" data-mp="2168bm3upv6ja">
            Book a Free Discovery Call
          </a>
          <p className="mt-6 text-gray-300" data-id="element-172" data-mp="1n8a51kmn0eec">
            No pressure, just a helpful conversation to see if we're a good fit.
          </p>
          <div className="mt-12 flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8" data-id="element-173" data-mp="2ex4tazn3u3bk">
            <div className="flex items-center" data-id="element-174" data-mp="2a5v7yb8l9m5h">
              <div className="h-10 w-10 rounded-full bg-[#8A9A5B] flex items-center justify-center mr-3" data-id="element-175" data-mp="2a4k3083eq8cs">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-176" data-mp="32n7k7cfa938l">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" data-id="element-177" data-mp="vz8l9l7dfold" />
                </svg>
              </div>
              <span data-id="element-178" data-mp="m7b7c6ozaiiy">Orange City, Iowa</span>
            </div>
            <div className="flex items-center" data-id="element-179" data-mp="r6xkkg4t3yrr">
              <div className="h-10 w-10 rounded-full bg-[#8A9A5B] flex items-center justify-center mr-3" data-id="element-180" data-mp="d8h2jt1hulub">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-181" data-mp="i7aids496oxn">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" data-id="element-182" data-mp="894krmphc4yl" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" data-id="element-183" data-mp="1xnstndyv34rv" />
                </svg>
              </div>
              <span data-id="element-184" data-mp="22mcdn8twa6hl">info@meyerbkt.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}